import React from 'react';
import HeaderTitle from 'header/components/title';

const Start1to1Header = () => (
  <HeaderTitle title="Work Privately With One Creative (1-to-1 Project)" />
);

export default Start1to1Header;



// WEBPACK FOOTER //
// ./pap0/components/header_title_1_1.jsx